import { translate } from "app/filters/i18nFilter";
import NewAssetButtonTracked from "app/pages/sales-intelligence/pages/home/containers/NewAssetButton/NewAssetButtonTracked";
import TutorialViewTracked from "app/pages/sales-intelligence/pages/home/containers/TutorialView/TutorialViewTracked";
import { StyledButtonsContainer } from "../../components/styles";
import type { ViewModelMetadata } from "../../types/models";

type Props = {
    metadata: ViewModelMetadata;
    onRedirectToSearch: () => void;
};

const SavedSearchesEmptyCardActions = ({ metadata, onRedirectToSearch }: Props) => {
    return (
        <StyledButtonsContainer>
            <NewAssetButtonTracked
                metadata={metadata}
                onClick={onRedirectToSearch}
            >
                {translate("si.pages.home.card.saved-searches.action.start-search")}
            </NewAssetButtonTracked>
            <TutorialViewTracked
                metadata={metadata}
                stateId="salesIntelligence-home-savedSearches"
            >
                {translate("si.pages.home.card.action.tutorial")}
            </TutorialViewTracked>
        </StyledButtonsContainer>
    );
};

export default SavedSearchesEmptyCardActions;
